import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Tooltip from "@material-ui/core/Tooltip";
import Input from "@material-ui/core/Input";
import PopupMessage from "../components/PopupMessage";
import ConfirmDialog from "../components/ConfirmDialog";
import {
  DRAWER_WIDTH,
  ACCOUNTS_TOOLBAR_HEIGHT,
  ACCOUNTS_TOOLBAR_TOP,
  MAIN_CONTENT_TOP,
} from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import CancelIcon from "@material-ui/icons/CancelOutlined";
import SaveIcon from "@material-ui/icons/SaveOutlined";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",

    position: "fixed",
    top: `${MAIN_CONTENT_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },
  redCell: {
    color: "red",
  },
  toolbar: {
    height: `${ACCOUNTS_TOOLBAR_HEIGHT}px`,
    zIndex: 1,
    position: "fixed",
    top: `${ACCOUNTS_TOOLBAR_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
  },
  spacer: {
    flex: "1 1 100%",
  },

  table: {
    border: "1px solid black",
    margin: "20px",
    width: 700,
  },
});

class AddEditUserDetailsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      viewPopup: false,
      permissionsLoaded: false,
      item: {},
      perms: [],
      buttonsDisabled: false,
      confirmPassword: "",
      inherit: "0",
      confirmNoPerm: false,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
  }

  componentDidMount() {
    let item;
    if (this.props.newUser) {
      item = { id: "0" };
    } else {
      item = this.props.item;
    }
    item.secureToken = this.props.secureToken;
    fetch("on_full_user_info", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          if (this.props.newUser) {
            reply.item.language = "English";
          }
          this.setState({ item: reply.item });
          this.setState({ perms: reply.item.perms });
          this.setState({ permissionsLoaded: true });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  handleConfirm(event, action) {
    this.setState({ confirmNoPerm: false });
    // action = 1 - confirmed
    if (action === 1) {
      this.save();
    }
  }

  handleCancel(e) {
    this.props.onResult(1, null);
  }

  handleSave(e) {
    let item = this.state.item;
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (this.props.newUser && (item.name === null || item.name.length < 5)) {
      this.setState({
        errorString: getErrorString(
          "user.login.id.error",
          "Login ID must be minimum 5 characters."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (
      this.props.newUser &&
      (item.password === null || item.password.length === 0)
    ) {
      this.setState({
        errorString: getErrorString(
          "login.newpassword.error",
          "New Password is required."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (
      item.password !== null &&
      item.password.length > 0 &&
      item.password.length < 8
    ) {
      this.setState({
        errorString: getErrorString(
          "login.passwordLength.error",
          "New Password must be at least 8 characters."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (
      item.password !== null &&
      item.password.length > 0 &&
      this.state.confirmPassword !== item.password
    ) {
      this.setState({
        errorString: getErrorString(
          "login.passwordNotMatch.error",
          "New and Confirm Passwords do not match."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (item.contact === null || item.contact.length === 0) {
      this.setState({
        errorString: getErrorString(
          "user.username.error",
          "User Name is required."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (item.email === null || item.email.length === 0) {
      this.setState({
        errorString: getErrorString(
          "company.email.error",
          "E-mail is required."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (item.phone === null || item.phone.length === 0) {
      this.setState({
        errorString: getErrorString(
          "company.phone.error",
          "Phone Number is required."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    let perms = this.state.perms;
    let anyPerm = false;
    let i;
    for (i = 0; i < perms.length; i++) {
      if (
        perms[i].read ||
        perms[i].write ||
        perms[i].create ||
        perms[i].delete ||
        perms[i].execute ||
        perms[i].show
      ) {
        anyPerm = true;
        break;
      }
    }
    if (anyPerm) {
      this.save();
    } else {
      this.setState({ confirmNoPerm: true });
    }
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ errorString: "" });
    if (this.state.notifyString.length > 0) {
      this.setState({ notifyString: "" });
      this.props.onResult(2, this.state.item);
    }
  }

  loadPermissions(userId) {
    fetch("on_user_permissions", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: userId,
        active: true,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ perms: reply.perms });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  includePermission(perm, right) {
    if (perm.objectType === "2" && right === "X") {
      return true;
    } else if (perm.objectType === "3" && right === "S") {
      return true;
    } else if (perm.objectType === "1" && right !== "X" && right !== "S") {
      if (perm.objectId === "CompanyProfile" || perm.objectId === "Profile") {
        if (right === "R" || right === "W") {
          return true;
        } else {
          return false;
        }
      } else if (perm.objectId === "EditIssueItems") {
        if (right === "D" || right === "W") {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
    return false;
  }

  handlePerm(event, index, right) {
    let perms = this.state.perms;
    if (right === "C") {
      perms[index - 1].create = event.target.checked;
    } else if (right === "D") {
      perms[index - 1].delete = event.target.checked;
    } else if (right === "R") {
      perms[index - 1].read = event.target.checked;
    } else if (right === "W") {
      perms[index - 1].write = event.target.checked;
    } else if (right === "X") {
      perms[index - 1].execute = event.target.checked;
    } else if (right === "S") {
      perms[index - 1].show = event.target.checked;
    }
    this.setState({ perms: perms });
  }

  handlePassword = (event) => {
    let myData = this.state.item;
    myData.password = event.target.value;
    this.setState({ item: myData });
  };

  handleConfirmPassword = (event) => {
    this.setState({ confirmPassword: event.target.value });
  };

  handleLoginId = (event) => {
    let myData = this.state.item;
    myData.name = event.target.value;
    this.setState({ item: myData });
  };

  handleLanguage = (event) => {
    let myData = this.state.item;
    myData.language = event.target.value;
    this.setState({ item: myData });
  };

  handleUserName = (event) => {
    let myData = this.state.item;
    myData.contact = event.target.value;
    this.setState({ item: myData });
  };

  handleEmail = (event) => {
    let myData = this.state.item;
    myData.email = event.target.value;
    this.setState({ item: myData });
  };

  handlePhone = (event) => {
    let myData = this.state.item;
    myData.phone = event.target.value;
    this.setState({ item: myData });
  };

  handleFax = (event) => {
    let myData = this.state.item;
    myData.fax = event.target.value;
    this.setState({ item: myData });
  };

  handleStreet = (event) => {
    let myData = this.state.item;
    myData.street = event.target.value;
    this.setState({ item: myData });
  };

  handleCity = (event) => {
    let myData = this.state.item;
    myData.city = event.target.value;
    this.setState({ item: myData });
  };

  handleState = (event) => {
    let myData = this.state.item;
    myData.state = event.target.value;
    this.setState({ item: myData });
  };

  handleZip = (event) => {
    let myData = this.state.item;
    myData.zip = event.target.value;
    this.setState({ item: myData });
  };

  handleSsoName = (event) => {
    let myData = this.state.item;
    myData.ssoName = event.target.value;
    this.setState({ item: myData });
  };

  handleInherit(e) {
    this.setState({ inherit: e.target.value });
    this.loadPermissions(e.target.value);
  }

  save() {
    this.setState({ buttonsDisabled: true });
    let item = this.state.item;
    item.perms = this.state.perms;
    item.secureToken = this.props.secureToken;
    fetch("on_add_update_user", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ buttonsDisabled: false });
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          if (this.props.newUser) {
            item.active = true;
            item.id = reply.item.id;
            this.setState({ item: item });
          }
          this.setState({ buttonsDisabled: false });
          this.setState({
            notifyString: this.props.newUser
              ? "New user has been created."
              : "The user has been updated. User re-login required for the changes to take effect.",
          });
          this.setState({ viewPopup: true });
        }
      })
      .catch((error) => {
        this.setState({ buttonsDisabled: false });
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  render() {
    const { classes } = this.props;
    let items = this.state.perms;
    let options = this.props.users;
    let { t } = this.props;
    return (
      <div>
        <div className={classes.tableWrapper}>
          {this.state.confirmNoPerm && (
            <ConfirmDialog
              title={t("confirmNoPermit.label")}
              text={t("noRights.label")}
              onCloseConfirm={this.handleConfirm}
            />
          )}

          {!this.state.permissionsLoaded &&
            this.state.errorString.length > 0 && (
              <h3 style={{ color: "red" }}>{this.state.errorString} </h3>
            )}

          {this.state.viewPopup && this.state.errorString.length > 0 && (
            <PopupMessage
              title="Error"
              text={this.state.errorString}
              error={true}
              onClosePopup={this.onClosePopup}
            />
          )}

          {this.state.viewPopup && this.state.notifyString.length > 0 && (
            <PopupMessage
              title="Information"
              text={this.state.notifyString}
              error={false}
              onClosePopup={this.onClosePopup}
            />
          )}

          {this.state.permissionsLoaded && (
            <div>
              <p style={{ marginLeft: 30 }}>
                <Typography variant="h6" color="primary">
                  &nbsp;&nbsp;
                  {this.props.newUser
                    ? t("newUser.label")
                    : t("editUser.label")}{" "}
                  :&nbsp;&nbsp;
                </Typography>
                <Button
                  onClick={this.handleSave}
                  color="primary"
                  disabled={this.state.buttonsDisabled}
                >
                  <SaveIcon />
                  &nbsp;
                  {t("save.button")}
                </Button>
                <Button
                  onClick={this.handleCancel}
                  color="primary"
                  disabled={this.state.buttonsDisabled}
                >
                  <CancelIcon />
                  &nbsp;
                  {t("cancel.button")}
                </Button>
              </p>
              <table style={{ margin: 30, width: 1600 }}>
                <Paper elevation={6}>
                  <tr>
                    {this.props.newUser && (
                      <td>
                        <Tooltip title={t("loginIdCharacters.label")}>
                          <TextField
                            margin="dense"
                            id="loginId"
                            label={t("loginId.label")}
                            type="text"
                            required
                            inputProps={{maxLength: 16,}}
                            onChange={this.handleLoginId}
                          />
                        </Tooltip>
                      </td>
                    )}
                    {!this.props.newUser && (
                      <td>
                        <TextField
                          margin="dense"
                          id="ssoName"
                          label={t("ssoUserName.label")}
                          type="text"
                          inputProps={{maxLength: 16,}}
                          defaultValue={this.state.item.ssoName}
                          onChange={this.handleSsoName}
                        />
                      </td>
                    )}
                    <td>
                      <Tooltip
                        title={
                          t("contactPersonHalf.label") +
                          " " +
                          t("adminInfo.label")
                        }
                      >
                        <TextField
                          margin="dense"
                          id="userName"
                          label={t("userName.label")}
                          type="text"
                          required
                          inputProps={{maxLength: 40,}}
                          defaultValue={this.state.item.contact}
                          onChange={this.handleUserName}
                        />
                      </Tooltip>
                    </td>
                    <td>
                      <Tooltip title={t("enterCorrectEmail.label")}>
                        <TextField
                          margin="dense"
                          id="email"
                          label={t("email.label")}
                          type="text"
                          required
                          inputProps={{maxLength: 250,}}
                          defaultValue={this.state.item.email}
                          onChange={this.handleEmail}
                        />
                      </Tooltip>
                    </td>
                    <td>
                      <Tooltip title={t("password.label")}>
                        <TextField
                          margin="dense"
                          id="password"
                          label={t("passwordField.label")}
                          type="password"
                          autoComplete="new-password"
                          required={this.props.newUser}
                          inputProps={{maxLength: 64,}}
                          onChange={this.handlePassword}
                        />
                      </Tooltip>
                    </td>
                    <td>
                      <TextField
                        margin="dense"
                        id="confirmPassword"
                        label={t("confirmPassword.label")}
                        type="password"
                        required={this.props.newUser}
                        inputProps={{maxLength: 64,}}
                        onChange={this.handleConfirmPassword}
                      />
                    </td>
                    <td>
                      <Typography variant="caption">
                        {t("lan.label")}&nbsp;&nbsp;
                      </Typography>
                      <FormControl>
                        <NativeSelect
                          style={{
                            height: 52,
                            verticalAlign: "textTop",
                            margin: 0,
                          }}
                          defaultValue={this.state.item.language}
                          input={<Input id="language" />}
                          onChange={(event) => this.handleLanguage(event)}
                        >
                          <option value="English">{t("english.label")}</option>
                          <option value="French">{t("french.label")}</option>
                          <option value="Spanish">{t("spanish.label")}</option>
                        </NativeSelect>
                      </FormControl>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <TextField
                        margin="dense"
                        id="street"
                        label={t("street.label")}
                        type="text"
                        inputProps={{maxLength: 50,}}
                        defaultValue={this.state.item.street}
                        onChange={this.handleStreet}
                      />
                    </td>
                    <td>
                      <TextField
                        margin="dense"
                        id="city"
                        label={t("city.label")}
                        type="text"
                        inputProps={{maxLength: 40,}}
                        defaultValue={this.state.item.city}
                        onChange={this.handleCity}
                      />
                    </td>
                    <td>
                      <TextField
                        margin="dense"
                        id="state"
                        label={t("state.label")}
                        type="text"
                        inputProps={{maxLength: 30,}}
                        defaultValue={this.state.item.state}
                        onChange={this.handleState}
                      />
                    </td>
                    <td>
                      <TextField
                        margin="dense"
                        id="zip"
                        label={t("zip.label")}
                        type="text"
                        inputProps={{maxLength: 15,}}
                        defaultValue={this.state.item.zip}
                        onChange={this.handleZip}
                      />
                    </td>
                    <td>
                      <TextField
                        margin="dense"
                        id="phone"
                        label={t("phoneNumber.label")}
                        type="text"
                        required
                        inputProps={{maxLength: 20,}}
                        defaultValue={this.state.item.phone}
                        onChange={this.handlePhone}
                      />
                      <br />
                      <Typography variant="caption" color="primary">
                        (XXX) XXX - XXXX
                      </Typography>
                    </td>
                    <td>
                      <TextField
                        margin="dense"
                        id="fax"
                        label={t("faxNumber.label")}
                        type="text"
                        inputProps={{maxLength: 20,}}
                        defaultValue={this.state.item.fax}
                        onChange={this.handleFax}
                      />
                      <br />
                      <Typography variant="caption" color="primary">
                        (XXX) XXX - XXXX
                      </Typography>
                    </td>
                    {this.props.newUser && (
                      <td>
                        <Typography variant="caption">
                          {t("inheritUserRights.label")}&nbsp;&nbsp;
                        </Typography>
                        <FormControl>
                          <NativeSelect
                            style={{
                              height: 52,
                              verticalAlign: "textTop",
                              margin: 0,
                            }}
                            defaultValue={this.state.inherit}
                            input={<Input id="inherit" />}
                            onChange={(event) => this.handleInherit(event)}
                          >
                            <option value="0">No Profile</option>
                            {options.map((n) => {
                              return <option value={n.id}>{n.name}</option>;
                            })}
                          </NativeSelect>
                        </FormControl>
                      </td>
                    )}
                  </tr>
                </Paper>
              </table>
              <div>
                <Typography
                  style={{ marginLeft: 30 }}
                  variant="h6"
                  color="textSecondary"
                >
                  {t("permissions.label")}
                </Typography>
                <Paper>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>{t("objName.header")}</TableCell>
                        <TableCell>{t("objId.header")}</TableCell>
                        <TableCell>{t("objType.header")}</TableCell>
                        <TableCell>{t("accessRights.header")}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {items.map((item) => {
                        return (
                          <TableRow key={item.index}>
                            <TableCell component="th" scope="row">
                              {item.objectName}
                            </TableCell>
                            <TableCell>{item.objectId}</TableCell>
                            <TableCell>
                              {"1" === item.objectType
                                ? t("dataObj.label")
                                : "2" === item.objectType
                                ? t("business.label")
                                : t("userInterface.label")}
                            </TableCell>
                            <TableCell>
                              {this.includePermission(item, "C") && (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={item.create}
                                      onChange={(event) =>
                                        this.handlePerm(event, item.index, "C")
                                      }
                                      value={item.index}
                                      color="default"
                                    />
                                  }
                                  label={t("create.label")}
                                />
                              )}
                              {this.includePermission(item, "D") && (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={item.delete}
                                      onChange={(event) =>
                                        this.handlePerm(event, item.index, "D")
                                      }
                                      value={item.index}
                                      color="default"
                                    />
                                  }
                                  label={t("delete.button")}
                                />
                              )}
                              {this.includePermission(item, "R") && (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={item.read}
                                      onChange={(event) =>
                                        this.handlePerm(event, item.index, "R")
                                      }
                                      value={item.index}
                                      color="default"
                                    />
                                  }
                                  label={t("read.label")}
                                />
                              )}
                              {this.includePermission(item, "W") && (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={item.write}
                                      onChange={(event) =>
                                        this.handlePerm(event, item.index, "W")
                                      }
                                      value={item.index}
                                      color="default"
                                    />
                                  }
                                  label={t("write.label")}
                                />
                              )}
                              {this.includePermission(item, "X") && (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={item.execute}
                                      onChange={(event) =>
                                        this.handlePerm(event, item.index, "X")
                                      }
                                      value={item.index}
                                      color="default"
                                    />
                                  }
                                  label={t("execute.label")}
                                />
                              )}
                              {this.includePermission(item, "S") && (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={item.show}
                                      onChange={(event) =>
                                        this.handlePerm(event, item.index, "S")
                                      }
                                      value={item.index}
                                      color="default"
                                    />
                                  }
                                  label={t("show.label")}
                                />
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Paper>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(AddEditUserDetailsPage));
